import React from 'react'


const ItemBulleted = ({ color, text }) => {
    return (
        <div className='w-full h-full flex items-center gap-[8px]'>
            <div className='w-[16px] h-[16px] rounded-full' style={{ backgroundColor: color }} />
            <p className='text-[10px]'>{text}</p>
        </div>
    )
}

const ContainerInfoLinerBar = () => {
    return (
        <div className='w-[200px] h-[32px] border-[1px] border-[#E5E7EB] px-[16px] py-[8px] flex items-center justify-center gap-[16px]'>
            <ItemBulleted color="#1677FF" text="Estimadas" />
            <ItemBulleted color="#1B1464" text="Trabajadas" />
        </div>
    )
}

export default ContainerInfoLinerBar